import styled from "@emotion/styled";
import {
  Button,
  Info,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledDrawerContainerDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "76px",
  height: "100%",
  padding: "48px",
});

export const StyledContentDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "76px",
});

export const StyledSelectionDiv = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  padding: "20px 30px",
  borderRadius: "12px",
  backgroundColor: theme.palette.grey[100],
}));

export const StyledSelectionLabelText = styled(Text)(({ theme }) => ({
  color: theme.palette.grey[600],
}));

export const StyledSelectionCountText = styled(Text)(({ theme }) => ({
  color: theme.palette.primary[500],
}));

export const StyledButtonsContainerDiv = styled("div")({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  alignItems: "center",
  gap: "48px",
});

export const StyledConfirmButton = styled(Button)({
  width: "100%",
});

export const StyledCancelButton = styled(Button)({
  justifySelf: "center",
  textDecoration: "underline",
});

export const StyledInformationDiv = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "20px",
  padding: "12px 20px",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: theme.palette.primary[500],
  backgroundColor: theme.palette.primary[50],
  borderRadius: "12px",
}));

export const StyledInformationIcon = styled(Info)(({ theme }) => ({
  flexShrink: 0,
  color: theme.palette.primary[500],
}));

export const StyledInformationContentDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

export const StyledInformationTitleText = styled(Text)(({ theme }) => ({
  color: theme.palette.primary[700],
}));

export const StyledInformationDescriptionDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});
